import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './LoginPage.css';

const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    const result = await login({ username, password });
    
    if (result.success) {
      const from = location.state?.from;
      const redirectState = location.state?.redirectState;
      
      // Check if user is admin and redirect accordingly
      if (result.user?.role === 'ADMIN') {
        navigate('/admin', { replace: true });
      } else if (from) {
        navigate(from, { state: redirectState });
      } else {
        navigate('/home');
      }
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  const handleGoogleLogin = () => {
    alert('Google login is not yet configured. Please use regular login for now.');
  };

  return (
    <div className="login-wrapper">
      {/* Background shapes */}
      <div className="login-shape shape1"></div>
      <div className="login-shape shape2"></div>

      <div className="login-container" data-aos="fade-up">
        <div className="login-image-container" data-aos="fade-right">
          <img
            src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%2Fid%2FOIP.rwr6SRa66XQuHOFFxei8hgHaFN%3Fpid%3DApi&f=1&ipt=f9ea1e6842e78099bf7d4a9559ccfd184d0fe058e6e9052fbb2ab9d0d1fcf501&ipo=images"
            alt="Reading Books"
            className="login-image"
          />
        </div>

        <div className="login-form" data-aos="fade-left">
          <h2>Welcome Back</h2>
          <p className="login-subtitle">Sign in to continue your BookVerse journey</p>
          {error && <div className="alert alert-error">{error}</div>}
          <form onSubmit={handleLogin}>
            <input
              type="text"
              placeholder="Username or Email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={loading}
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
            <button type="submit" disabled={loading}>
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <div style={{ margin: '20px 0', textAlign: 'center', color: '#666' }}>or</div>
          
          <button 
            type="button" 
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: 'white',
              color: '#757575',
              border: '1px solid #dadce0',
              borderRadius: '8px',
              fontSize: '16px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              transition: 'box-shadow 0.3s'
            }}
            onMouseOver={(e) => e.target.style.boxShadow = '0 1px 3px rgba(0,0,0,0.3)'}
            onMouseOut={(e) => e.target.style.boxShadow = 'none'}
            onClick={handleGoogleLogin}
          >
            <svg width="18" height="18" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Continue with Google
          </button>
          <p className="register-text">
            Don't have an account? <Link to="/register">Register here</Link>
          </p>
          
          <div style={{ 
            marginTop: '20px', 
            padding: '10px', 
            textAlign: 'center', 
            borderTop: '1px solid #eee'
          }}>
            <Link 
              to="/admin-login" 
              style={{ 
                color: '#666', 
                textDecoration: 'none',
                fontSize: '12px'
              }}
            >
              🔐 Administrator Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
